// Время агентов: один часовой пояс, в котором OMA называет агентам время, а интерфейс — сроки ожиданий.
// Владелец сверяет «ждёт до 14:30 МСК» с часами в шапке, где бы он ни был.

export const DEFAULT_AGENT_TZ = 'Europe/Moscow'

const NAMES: Record<string, string> = { 'Europe/Moscow': 'МСК', UTC: 'UTC', 'Etc/UTC': 'UTC' }

export function validTimeZone(tz: unknown): tz is string {
  if (typeof tz !== 'string' || !tz) return false
  try {
    new Intl.DateTimeFormat('ru-RU', { timeZone: tz })
    return true
  } catch {
    return false
  }
}

const zone = (tz: string | null | undefined): string => (validTimeZone(tz) ? tz : DEFAULT_AGENT_TZ)

/** «МСК», «UTC» или смещение «UTC+2». */
export function tzLabel(tz: string | null | undefined): string {
  const z = zone(tz)
  if (NAMES[z]) return NAMES[z]!
  const off = new Intl.DateTimeFormat('ru-RU', { timeZone: z, timeZoneName: 'shortOffset' }).formatToParts(new Date()).find((p) => p.type === 'timeZoneName')?.value ?? ''
  return off.replace('GMT', 'UTC').replace(/^UTC$/, 'UTC+0')
}

const fmtCache = new Map<string, Intl.DateTimeFormat>()
function fmt(z: string, withDate: boolean): Intl.DateTimeFormat {
  const key = `${z}|${withDate}`
  let f = fmtCache.get(key)
  if (!f) {
    f = new Intl.DateTimeFormat('ru-RU', { timeZone: z, hour: '2-digit', minute: '2-digit', hourCycle: 'h23', ...(withDate ? { day: '2-digit', month: '2-digit' } : {}) })
    fmtCache.set(key, f)
  }
  return f
}

const dayKey = (t: number, z: string): string => new Intl.DateTimeFormat('en-CA', { timeZone: z, year: 'numeric', month: '2-digit', day: '2-digit' }).format(t)

/** Время во времени агентов: «14:30» сегодня, иначе «21.10, 14:30»; label — с «МСК». */
export function agentTime(iso: string | number | Date, tz: string | null | undefined, opts: { label?: boolean; now?: number } = {}): string {
  const z = zone(tz)
  const t = new Date(iso).getTime()
  if (Number.isNaN(t)) return '—'
  const today = dayKey(t, z) === dayKey(opts.now ?? Date.now(), z)
  const s = fmt(z, !today).format(t)
  return opts.label === false ? s : `${s} ${tzLabel(z)}`
}
